import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { operations, selectors } from './duck';
import Presenter from './presenter';

// TODO: See discussion at: https://github.com/reduxjs/react-redux/issues/779

const mapStateToProps = (state, props) => ({
  derived: {
    ambiences: selectors.selectAmbienceTags(state),
    amenities: selectors.selectAmenities(state),
    cities: selectors.selectCities(state),
    cuisines: selectors.selectCuisines(state),
    dishTags: selectors.selectDishTags(state),
    eatery: selectors.selectEatery(state, props),
    editedSlug: selectors.selectEditedSlug(state),
    isSaving: selectors.selectIsSaving(state),
  },
});

const mapDispatchToProps = dispatch => bindActionCreators(operations, dispatch);

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(Presenter);

export default Container;
